export default "__VITE_ASSET__Cz3SgxBU__"